import api from '../api';

export interface AutoCompleteMakeParams {
  field: string;
  input: string;
  model?: string;
  make?: string;
  year?: number;
}

export const autocomplete = async (params: AutoCompleteMakeParams) => {
  const result = await api.get('/models', {
    params,
  });
  return result.data;
};
